// extracted by mini-css-extract-plugin
export default {"button":"Menu_button__+yMkA","container":"Menu_container__xQ5Ze","open":"Menu_open__gMGvD"};